/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Teacher10Inputs */

const en__field_enum_mzs_teacher10 = /** @type {(inputs: _Field_Enum_Mzs_Teacher10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`teacher/ employee at Goethe-University (and other)`)
};

const de__field_enum_mzs_teacher10 = /** @type {(inputs: _Field_Enum_Mzs_Teacher10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrende/r/ Wissenschaftliche/r Mitarbeiter/in der Goethe Uni (und Sonstige)`)
};

/**
* | output |
* | --- |
* | "teacher/ employee at Goethe-University (and other)" |
*
* @param {_Field_Enum_Mzs_Teacher10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_teacher10 = /** @type {((inputs?: _Field_Enum_Mzs_Teacher10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Teacher10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_teacher10(inputs)
	return de__field_enum_mzs_teacher10(inputs)
});
export { _field_enum_mzs_teacher10 as "_field_enum_MZS_TEACHER" }